import { render, staticRenderFns } from "./EgressProfileCompetenceMentionForm.vue?vue&type=template&id=5b073cd7&scoped=true"
import script from "./EgressProfileCompetenceMentionForm.vue?vue&type=script&lang=js"
export * from "./EgressProfileCompetenceMentionForm.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=5b073cd7&prod&scoped=true&lang=css&external"
import style1 from "./EgressProfileCompetenceMentionForm.vue?vue&type=style&index=1&id=5b073cd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b073cd7",
  null
  
)

export default component.exports